/* eslint-disable no-nested-ternary */
import { useNavigateWithOfflineMode, useScreenSize } from '@hooks';
import { Button, Flex, Image, Typography } from '@styles';
import { ReactComponent as EyeIcon } from '@svgs/eye.svg';
import { bool, func, number, string } from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { Icon } from '../Icon';
import {
  cardLayoutByState,
  imageLayoutByDevice,
} from './ActivityExerciseCard.layoutProps';

const ActivityExerciseCard = ({
  id,
  imageUrl,
  isDisabled,
  // isNew,
  onPress,
  subtitleText,
  titleText,
  wasSeenCount,
}) => {
  const { device, isLaptop, isMobile } = useScreenSize();
  const { navigate } = useNavigateWithOfflineMode();

  const additionalExercisesState = useSelector(
    (state) => state.activitiesSlice.additionalExercisesState
  );

  const handleActivityExerciseCardButtonClick = () => {
    navigate(additionalExercisesState, { state: { id } });
  };

  const cardStyle = cardLayoutByState[isDisabled];

  return (
    <Button
      disabled={isDisabled}
      height={isLaptop ? 'auto' : '100%'}
      maxHeight={isMobile ? 372 : 'none'}
      onClick={onPress || handleActivityExerciseCardButtonClick}
      p={0}
      position="relative"
      variant="textButton"
      width="100%"
    >
      <Flex
        backgroundColor={cardStyle.containerBackgroundColor}
        flexDirection={isMobile ? 'column' : 'row'}
        gap={isMobile ? 16 : 24}
        height={isLaptop ? 'auto' : '100%'}
        p={isMobile ? 16 : 24}
        width="100%"
      >
        <Image
          height={imageLayoutByDevice[device]?.height || '170'}
          opacity={cardStyle.imageOpacity}
          src={imageUrl}
          style={{ objectFit: 'cover' }}
          width={isMobile ? '100%' : '40%'}
        />
        <Flex
          flexDirection="column"
          justifyContent="space-between"
          width={isMobile ? '100%' : '60%'}
        >
          {subtitleText ? (
            <Flex flexDirection="column">
              <Typography
                color={cardStyle.subtitleColor}
                textAlign="left"
                variant="MS-regular-s16-lh25"
              >
                {subtitleText}
              </Typography>
              <Typography
                color={cardStyle.typographyColor}
                textAlign="left"
                variant="MS-semibold-s20-lh30"
              >
                {titleText}
              </Typography>
            </Flex>
          ) : (
            <Typography
              color={cardStyle.typographyColor}
              textAlign="left"
              variant="MS-semibold-s20-lh30"
            >
              {titleText}
            </Typography>
          )}
          <Flex>
            <Icon color={cardStyle.iconColor} mr={2} SVG={EyeIcon} />
            <Typography
              color={cardStyle.typographyColor}
              variant="MS-regular-s14-lh22"
            >
              {wasSeenCount}
            </Typography>
          </Flex>
        </Flex>
      </Flex>
    </Button>
  );
};

ActivityExerciseCard.defaultProps = {
  // isNew: false,
  onPress: null,
  subtitleText: null,
};

ActivityExerciseCard.propTypes = {
  id: string.isRequired,
  imageUrl: string.isRequired,
  isDisabled: bool.isRequired,
  // isNew: bool,
  onPress: func,
  subtitleText: string,
  titleText: string.isRequired,
  wasSeenCount: number.isRequired,
};

export default ActivityExerciseCard;
